module.exports = __webpack_public_path__ + "img/wljg007.c59eddb9.jpg";